// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'processes'

/**
 * Processes Model Interface (auto-generated from Drizzle schema)
 */
export interface ProcessesModel {
  id: string
  orgId: string
  workspaceId: string
  userId?: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  name: string
  title: string
  description?: string
  version?: string
  status: string
  category: string
  startStepId?: string
  documentId?: string
  flowId: string
  trigger?: Record<string, unknown>
  inputSchema?: Record<string, unknown>
  outputSchema?: Record<string, unknown>
  executionConfig?: Record<string, unknown>
  maxSubprocessDepth?: number
  executorAgentId?: string
  statistics?: Record<string, unknown>
  requiredCapabilities?: string[]
  archived: boolean
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
      "id": {
          "type": "string",
          "maxLength": 100
      },
      "orgId": {
          "type": "string",
          "maxLength": 100
      },
      "workspaceId": {
          "type": "string",
          "maxLength": 100
      },
      "userId": {
          "type": "string",
          "maxLength": 100
      },
      "createdAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "updatedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "metadata": {
          "type": "object"
      },
      "extended": {
          "type": "object"
      },
      "name": {
          "type": "string",
          "maxLength": 500
      },
      "title": {
          "type": "string",
          "maxLength": 500
      },
      "description": {
          "type": "string",
          "maxLength": 100000
      },
      "version": {
          "type": "string",
          "maxLength": 200
      },
      "status": {
          "type": "string",
          "maxLength": 50
      },
      "category": {
          "type": "string",
          "maxLength": 200
      },
      "startStepId": {
          "type": "string",
          "maxLength": 100
      },
      "documentId": {
          "type": "string",
          "maxLength": 100
      },
      "flowId": {
          "type": "string",
          "maxLength": 100
      },
      "trigger": {
          "type": "object"
      },
      "inputSchema": {
          "type": "object"
      },
      "outputSchema": {
          "type": "object"
      },
      "executionConfig": {
          "type": "object"
      },
      "maxSubprocessDepth": {
          "type": "integer"
      },
      "executorAgentId": {
          "type": "string",
          "maxLength": 100
      },
      "statistics": {
          "type": "object"
      },
      "requiredCapabilities": {
          "type": "array",
          "items": {
              "type": "string"
          }
      },
      "archived": {
          "type": "boolean"
      },
      "tenantId": {
          "type": "string",
          "maxLength": 100
      }
  },
  required: [
      "id",
      "orgId",
      "createdAt",
      "updatedAt",
      "name",
      "title",
      "status",
      "archived",
      "workspaceId",
      "category",
      "flowId"
  ],
  indexes: [
      [
          "orgId",
          "workspaceId",
          "status",
          "createdAt"
      ],
      [
          "orgId",
          "status",
          "category"
      ],
      [
          "flowId"
      ]
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
